import React, { useState } from "react"
import { OUR_CLIENTS } from "../../data/home/our-clients"
import { Swiper, SwiperSlide } from "swiper/react"
import { SwiperButtonNext } from "../../components/swiper-buttons/ButtonNext"
import { SwiperButtonPrevious } from "../../components/swiper-buttons/ButtonPrevious"
import { OneClient } from "../client"

import "swiper/css"
import "./index.scss"

export const OurClients = () => {
    const [cardNumber, setCardNumber] = useState(1)

    const handleSwipe = (swiper) => {
        if (swiper.swipeDirection === "prev") {
            setCardNumber(cardNumber - 1)
        } else if (swiper.swipeDirection === "next") {
            setCardNumber(cardNumber + 1)
        }
    }

    return (
        <div className="our-clients">
            <div className="our-clients-header">
                <p className="t-s5">
                    review The feedback from
                    <h1 className="t-s3">Our Clients</h1>
                </p>
                <h2 className="t-nav">
                    {String("0" + cardNumber).slice(-2)}/
                    {String("0" + OUR_CLIENTS.length).slice(-2)}
                </h2>
            </div>
            <Swiper spaceBetween={32} slidesPerView={1} allowTouchMove={true} simulateTouch={true} noSwiping={false}
                onSlideChange={(swipe) => handleSwipe(swipe)}>

                <div className="our-clients-list">
                    {OUR_CLIENTS.map((el, id) => (
                        <SwiperSlide key={el.name + id}>
                            <OneClient {...el} />
                        </SwiperSlide>
                    ))}
                </div>
                {cardNumber < OUR_CLIENTS.length && (
                    <SwiperButtonNext
                        className={"swiper-button-next"}
                        setCardNumber={setCardNumber}
                        cardNumber={cardNumber}
                    />
                )}
                {cardNumber > 1 && (
                    <SwiperButtonPrevious
                        className={"swiper-button-previous"}
                        setCardNumber={setCardNumber}
                        cardNumber={cardNumber}
                    />
                )}
            </Swiper>
        </div>
    )
}
